import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const geometryUpdates = {
  actions,
  getters,
  mutations,
  namespaced: true,
  state: {
    decostitchApplied: false,
    upgradeOptions: {},
    disabledComponents: {}
  },
};

export default geometryUpdates;
